<template>
	<!-- Prezzo, quantita' e spedizione modificabili di un'inserzione eBay:
	     condivisi tra la tabella (desktop) e la card (telefono) di views/ebay/Index.vue -->
	<div class="seller-fields">
		<v-text-field
			v-model="item.sellerPrice"
			label="Prezzo"
			type="number"
			dense
			outlined
			hide-details
			:suffix="item.sellerCurrency"
			@change="$emit('price', item)"
			@click="$emit('price', item)"
		></v-text-field>
		<v-text-field v-model="item.sellerQt" label="Quantità" type="number" dense outlined hide-details @change="$emit('quantity', item)" @click="$emit('quantity', item)"></v-text-field>
		<v-select
			v-model="item.shipping"
			:items="shippingItems"
			label="Spedizione"
			item-text="title"
			item-value="value"
			dense
			outlined
			hide-details
			@change="$emit('shipping', item)"
		></v-select>
	</div>
</template>

<script>
export default {
	name: 'EbaySellerFields',
	props: {
		// riga della tabella: i campi seller* vengono modificati sul posto, come prima
		item: { type: Object, required: true },
		shippingItems: { type: Array, default: () => [] },
	},
};
</script>

<style scoped>
/* ::v-deep perche' la classe .v-input e' dentro i componenti Vuetify */
.seller-fields ::v-deep .v-input + .v-input {
	margin-top: 8px;
}
</style>
